import { createFileRoute, redirect } from '@tanstack/react-router';

import {
  adminUsersListDefaultSearch,
  usersSchema,
} from '../../../users/index.route';

/** Legacy `/admin/users` → `/users` */
export const Route = createFileRoute('/_private/_route/_internal/admin/users/')(
  {
    beforeLoad: ({ search }) => {
      const parsed = usersSchema.safeParse(search);
      throw redirect({
        replace: true,
        search: parsed.success ? parsed.data : adminUsersListDefaultSearch,
        to: '/users',
      });
    },
    validateSearch: usersSchema,
  },
);
